export default {
  error: {
    resultsSending: 'Erreur lors de l\'envoi des résultats'
  }
}
